<template>
    <div class="knowledgePoints">
      <el-button style="width: 100%" size="small" type="primary" @click="handleNodeClick({id:''})" icon="el-icon-star-off" plain>全部</el-button>
      <el-tree
        :data="knowledgePoints"
        node-key="id"
        default-expand-all
        :props="defaultProps"
        draggable
        :expand-on-click-node="false"
        @node-click="handleNodeClick"
      >
          <span class="custom-tree-node"
                slot-scope="{ node, data }"
                :title="node.label"
          >
            {{ node.label }}
          </span>
      </el-tree>
    </div>
</template>

<script>
  /**
   *   知识点 树。
   *   create by wjl at 2021.7.8
   */
    export default {
    name: "knowledgePoints",
    props: {
      value: {
        type: Object,
        default: ()=>{},
      },
    },
    components: {},
    data() {
      return {
        currentValue:this.value,
        knowledgePoints:[],
        defaultProps: {
          label: "name"
        },
      };
    },
    watch: {
      value: {
        handler(val) {
          if (val) {
            this.currentValue = val;
          } else {
            this.currentValue = {}
          }
        },
        immediate: true,
        deep: true,
      },
      currentValue: {
        handler(val) {
          this.$emit("input", val);
        },
        immediate: true,
        deep: true,
      },
    },
    created() {
     let knowledgePoints = sessionStorage.getItem('knowledgePoints');
     if (knowledgePoints){
       this.knowledgePoints = JSON.parse(knowledgePoints)
     }
    },
    mounted() {},
      methods:{
        handleNodeClick(data) {
          //点击素材目录
          this.$emit("knowledgePointsNodeClick", data);
        },
      }
    }
</script>

<style scoped lang="scss">
.knowledgePoints{
  width: 200px;
  padding: 0 3px;
  height: 100%;
  overflow-y: auto;
 /deep/ .custom-tree-node{
    max-width: 190px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/single_resource_course/components/knowledgePoints.vue